/** @deprecated use leitenContentLoading instead */
export const initialContentLoading = (value, initialStatus) => ({
    content: value,
    status: initialStatus || "loading",
    error: undefined,
    fetchError: undefined,
    payload: undefined,
    requestId: undefined,
});
